/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Taxonomy_Issue_Statement_Empty_BsInputs */

const en_statement_taxonomy_issue_statement_empty_bs = /** @type {(inputs: Statement_Taxonomy_Issue_Statement_Empty_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add at least one balance-sheet row`)
};

const nl_statement_taxonomy_issue_statement_empty_bs = /** @type {(inputs: Statement_Taxonomy_Issue_Statement_Empty_BsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg minstens één balansregel toe`)
};

/**
* | output |
* | --- |
* | "Add at least one balance-sheet row" |
*
* @param {Statement_Taxonomy_Issue_Statement_Empty_BsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_issue_statement_empty_bs = /** @type {((inputs?: Statement_Taxonomy_Issue_Statement_Empty_BsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Issue_Statement_Empty_BsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_issue_statement_empty_bs(inputs)
	return en_statement_taxonomy_issue_statement_empty_bs(inputs)
});